import { render, staticRenderFns } from "./FoodOrder.vue?vue&type=template&id=711c97b3&scoped=true"
import script from "./FoodOrder.vue?vue&type=script&lang=js"
export * from "./FoodOrder.vue?vue&type=script&lang=js"
import style0 from "./FoodOrder.vue?vue&type=style&index=0&id=711c97b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711c97b3",
  null
  
)

export default component.exports